"use client";

import { useDialog } from "@/hooks/useDialog";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { useParams, useRouter } from "next/navigation";
import { AppRoutesEnum } from "@/constants/constants";
import { LocationPinIcon } from "@/components/Icons";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const LocationChangePopup = ({
  onDismiss,
}: {
  onDismiss: () => void;
}) => {
  const { isDialogOpen, closeDialog } = useDialog(true);
  const { t } = useClientTranslations();
  const router = useRouter();
  const params = useParams();
  const lang = params?.lang as string;
  const dialect = params?.dialect as string;

  const handleUpgrade = () => {
    onDismiss();
    closeDialog();
    router.push(`/${lang}/${dialect}${AppRoutesEnum.PAYWALL}`);
  };

  const handleDismiss = () => {
    onDismiss();
    closeDialog();
  };

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent
        hideCloseButton
        preventCloseOnOutsideClick
        className="max-w-[340px] gap-0 rounded-2xl border border-[var(--grey-3)] bg-[var(--grey-1)] p-4 pt-8"
      >
        <div className="flex flex-col items-center p-6 pb-5">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--grey-3)]">
            <LocationPinIcon size={36} />
          </div>

          <DialogHeader className="mb-2 flex flex-col items-center">
            <DialogTitle className="text-center text-lg font-bold text-white">
              {t("popups.locationChange.title")}
            </DialogTitle>
            <DialogDescription className="text-center text-sm font-semibold text-[#ef4444]">
              {t("popups.locationChange.subtitle")}
            </DialogDescription>
          </DialogHeader>

          <p className="mb-4 mt-4 text-center text-sm leading-relaxed text-[var(--grey-text)]">
            {t("popups.locationChange.body")}
          </p>
        </div>

        <DialogFooter className="flex flex-col gap-2.5 px-6 sm:flex-col">
          <button
            onClick={handleUpgrade}
            className="w-full rounded-xl bg-stg-primary-cta py-3.5 text-sm font-bold text-white"
          >
            {t("popups.locationChange.upgradeCta")}
          </button>
          <button
            onClick={handleDismiss}
            className="w-full py-2.5 text-sm font-medium text-[var(--grey-text)]"
          >
            {t("popups.locationChange.dismissCta")}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
